import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";

pageTitleStyles.titleText = {
    variant: "h1",
    size: "24px",
};
